import { AnalyticsContext } from "@/Contexts/AnalyticsContext";
import { CookieManagerContext } from "@/Contexts/CookieManagerContext";
import { listenToAppEvent, sendEventToApp } from "@/utils/appCommunication";
import { PropsWithChildren, useContext, useEffect } from "react";

export function MobileAppTracking({ children }: PropsWithChildren) {
    const { saveCookieSettingsAndCloseAll } = useContext(CookieManagerContext);
    const analytics = useContext(AnalyticsContext);

    useEffect(() => {
        listenToAppEvent("setTrackingStatus", (canTrack) => {
            saveCookieSettingsAndCloseAll(
                {
                    analytics: true,
                    advertising: canTrack,
                },
                analytics,
            );
        });
        sendEventToApp("requestTracking", {});
    }, []);

    return children;
}
